module.exports = __webpack_public_path__ + "static/media/support.f215c12a.svg";